module.exports = __webpack_public_path__ + "static/funny-pic-0e78e9637b467840dbac85a4b55ad442.jpg";